export var NotificationDeliverySchedule;
(function (NotificationDeliverySchedule) {
    NotificationDeliverySchedule["sendNow"] = "send_now";
    NotificationDeliverySchedule["scheduleDate"] = "schedule_date";
})(NotificationDeliverySchedule || (NotificationDeliverySchedule = {}));
